import configapi from "../../api/configapi";

const state = () => ({
  pluginSettings: [],
  theme: 1,
  credential: {
    apiKey: null,
    apiSecret: null,
    apiEncryptedUser: null,
    locale: null,
    banner: null,
    brand: "GIOIELLERIA_ITALIANA",
    isBO: false
  },
  isPluginB2C: false,
  isGioielleriaItalianaB2B: false,
  isAma: false,
  showOnlyPublicPrice: false,
  ready: false,
});

// getters
const getters = {
  getPluginSettings: (state) => {
    return state.pluginSettings;
  },
  getCredential: (state) => {
    return state.credential;
  },
  isPluginB2C: (state) => {
    return state.isPluginB2C;
  },
  isGioielleriaItalianaB2B: (state) => {
    return state.isGioielleriaItalianaB2B;
  },
  isAma: (state) => {
    return state.isAma;
  },
  isReady: (state) => {
    return state.ready;
  },
};

// actions
const actions = {
  getPluginLayout({ commit }, search) {
    configapi.getPluginLayout((layout) => {
      commit("setPluginSettings", layout);
    });
  },
};

// mutations
const mutations = {
  setCredential(state, credential) {
    if (credential) {
      state.credential.apiKey = credential.apiKey;
      state.credential.apiSecret = credential.apiSecret;
      state.credential.apiEncryptedUser = credential.apiEncryptedUser;
      state.credential.locale = credential.locale;
      state.credential.banner = credential.banner;
      state.credential.brand = !!credential.brand && credential.brand == "ama" ? "AMA" : state.credential.brand;
      state.isGioielleriaItalianaB2B = !!state.credential.apiEncryptedUser && state.credential.brand == "GIOIELLERIA_ITALIANA";
      state.isPluginB2C = !state.credential.apiEncryptedUser;
      state.isAma = state.credential.brand == "AMA";
      state.credential.isBO = !!credential.isBO;
    }
  },
  setPluginSettings(state, value) {
    state.pluginSettings = value;
  },
  setReady(state, value) {
    state.ready = value;
  },
  setTheme(state, value) {
    state.theme = value;
  },
  //maggiorazione prezzi attiva 
  setShowOnlyPublicPrice(state, value) {
    state.showOnlyPublicPrice = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
